import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles(theme => ({
  nested: {
    paddingLeft: theme.spacing(5),
    '&.MuiListItem-gutters': {
      paddingRight: 0,
    },
  },
  grid: {
    border: `1px solid rgba(255,255,255,.3)`,
    borderRadius: 10,
    padding: '5px 0 5px 10px',
    background: theme.colors.dark.darkBlue,
  },
  item: {
    border: `1px solid rgba(255,255,255,.3)`,
    borderRadius: 10,
  },
  selected: {
    border: `1px solid ${theme.colors.orange.orange}`,
    background: 'rgba(0, 0, 0, 0.08)',
  },
}));
